<template>
  <div>
    <span @click="onTeamClicked" style="cursor: pointer;">{{ team.name }} (<span class="num-wins">{{ team.won }}</span> - <span class="num-losses">{{ team.lost }}</span>)</span>
    <b-modal @close="onModalClosed" :active="modalOpened" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          <div class="team-name" style="text-align: center;">{{ team.name }} (<span class="num-wins">{{ team.won }}</span> - <span class="num-losses">{{ team.lost }}</span>)</div>
          <div class="team-captain" style="text-align: center;">Captain {{ team.captain.name | capitalize }}</div>
          <div class="team-matches-wrapper" v-if="matches.length > 0">
            <div class="team-match-detail" v-for="match of matchesSorted" :key="match.id">
              <div>{{ match.date | formatDate }}</div>
              <div>{{ match.time }}pm on court {{ match.court }}</div>
              <div class="team-opponent">Opponent: {{ teams[`${team.league} ${team.name == match.home ? match.away : match.home}`].name }}</div>
              <div class="team-game-scores" v-if="match.done">
                <div v-for="(game, index) of match.games" :key="match.id.toString() + ' ' + index.toString()">
                  <span :class="classesForPoints(match, index, match.home == team.name ? 0 : 1)">{{ match.home == team.name ? match.games[index][0] : match.games[index][1] }}</span> - <span :class="classesForPoints(match, index, match.home == team.name ? 1 : 0)">{{ match.away == team.name ? match.games[index][0] : match.games[index][1] }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: "ScheduleTeamDetail",
    props: {
      season: {
        type: Object,
        required: true
      },
      team: {
        type: Object,
        required: true
      }
    },
    inject: ['teams'],
    computed: {
      matchesSorted() {
        let sortedMatches = this.matches.slice();
        sortedMatches.sort(this.$store.getters.matchSorter);
        return sortedMatches;
      }
    },
    data() {
      return {
        modalOpened: false,
        matches: []
      }
    },
    watch: {
      modalOpened(value) {
        if (value) {
          let url = `${this.$apiRoot}/seasons/${this.season.id}/leagues/${this.team.league}/teams/${this.team.id}/matches_list/`;
          this.modalLoading = true;
          let promise = this.axios.get(url);
          promise.then(result => {
            this.matches = result.data;
            this.modalLoading = false;
          });
          promise.catch(() => {
            this.matches = [];
            this.modalLoading = false;
          });
        }
      }
    },
    methods: {
      onTeamClicked() {
        this.modalOpened = true;
      },
      onModalClosed() {
        this.modalOpened = false;
      },
      classesForPoints(match, index, innerIndex) {
        return +match.games[index][innerIndex] < +match.games[index][1 - innerIndex] ? ["num-losses"] : ["num-wins"];
      }
    },
    filters: {
      formatDate(date) {
        return moment(date).format("MMMM Do YYYY");
      }
    }
  }
</script>

<style lang="scss">
.team-matches-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  align-content: flex-start;
}
.team-match-detail {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  margin: 0.5rem;
  padding: 0.25rem;
  /* Assuming no more than 15 matches per team per season right now. */
  @for $n from 1 through 15 {
    $first-start: hsla((($n * 45) % 360), 100%, 80%, 0.3);
    $first-end: lighten(transparentize($first-start, 0.2), 0.1);
    $second-start: hsla((($n * 45 + 45) % 360), 100%, 80%, 0.2);
    $second-end: lighten(transparentize($second-start, 0.2), 0.1);
    &:nth-child(#{$n}) {
      background: linear-gradient(to left, $first-start, $first-end), linear-gradient(to right, $second-start, $second-end);
    }
  }
}
</style>